module.exports = __webpack_public_path__ + "img/info-remove.7a4e4017.svg";